<template>
  <div class="container">
    <div class="navi">
        <span class="icon-arrow-left" @click="goto('/pest-abstract')"></span>
    </div>
    <div class="title">您的房屋情况是？</div>
    <!-- <img class="prepay-img" src='../../assets/img/other/prepay-amount.png'> -->
    <br>
    <div class="main">
      <div class="btn-long btn1 no-margin-top"  @click="goNext()">
        <div>正在居住<br><span class="btn-intro">我正在住 / 即将住的房子想要除虫</span></div>
      </div>
      <!-- 
      <div class="btn-long btn2" @click="orderUpdate('house_status',2,'/pest-step2')">
        <div>即将入住<br><span class="btn-intro">我即将入住的房子想要除虫</span></div>
      </div> 
      -->
      <div class="btn-long btn3" @click="orderUpdate('house_status',3,'/pest-step2-moveout')">
        <div>即将退房<br>
          <span class="btn-intro">房东 / 中介要求退房前进行除虫</span>
        </div>
        <!-- <img class="discount" src='../../assets/img/pest/house/99.svg'> -->
      </div>
    </div>
    <img :src="pixelURL('move','guimo')" class="hide">
  </div>
</template>

<script>
export default {
  name: 'step1',

  methods: {
    goNext(){
      if(this.order.data.house_status==3){
        this.order.data.pest_standard = false;
        this.order.data.pest_mouse = false;
        this.order.data.pest_german = false;
      }
      this.orderUpdate('house_status',1,'/pest-step2');
    }
  },

  data () {
    return {
      order:{
        service:'pest',
        data:{
          house_type: "",
          house_status: "",
          room_qty:1,
          extra_area:'',
          extra_granny:'',
          pest_standard:false,
          pest_mouse:false,
          pest_german:false,
          address_name: "",
          address_phone: "",
          address_state: "NSW",
          address_suburb: "",
          address_street: "",
          address_unit: "",
          address_postcode: "",
          floor:"",
          parking:"",
          msg:"",
          msgAttach:"",
          type_id:"1550735960",
          coupon_title:"",
          coupon_id:"",
          couponLocked:"",
          couponValue:0,
        },
        temp:{
          isAM:'',
          isPM:'',
          isDate:''
        }
      }
    }
  },

  created: function () {
    //如果LS存在老的下单信息
    if (localStorage.savedPest){
      //如果LS不存在order字段，则将老下单信息覆盖LS的order字段
      if(!localStorage.order){
        localStorage.order = localStorage.savedPest;
      }//如果LS存在order字段，判断其是否属于当前服务类型：如果否，则将老下单信息覆盖LS的order字段
    }
    if (localStorage.order) {
      let localParsed = JSON.parse(localStorage.order);
      if(localParsed.service == "pest"){
        this.order = localParsed;
      }
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

.btn-long{
  width: 85%;
  height: 120px;
  cursor: pointer;
  color: #fff;
  display: flex;
  align-items: center;
  border-radius: 5px;
  font-size: 1.2em;
  margin: 0 auto;
  margin-top: 26px;
  padding-left:6vw;
  box-sizing:border-box;
  text-align:left;
  font-weight:bold;
}

.btn-intro{
  font-size:0.7em;
  font-weight:normal;
}


.no-margin-top{
  margin-top:0;
}

.btn1{
  background: rgb(28, 199, 58);
  background:url('../../assets/img/pest/house/zhengzai.svg') bottom right no-repeat,linear-gradient(90deg, #1CC73A 0%,#9EF386 100%);
  -webkit-box-shadow: 0 10px 16px -10px rgba(28, 199, 58, 0.8);
  -moz-box-shadow: 0 10px 16px -10px rgba(28, 199, 58, 0.8);
  box-shadow: 0 10px 16px -10px rgba(28, 199, 58, 0.8);
}

.btn2{
  background: rgb(85, 156, 251);
  background:url('../../assets/img/pest/house/jijiang.svg') bottom right no-repeat,linear-gradient(90deg, #559CFB 0%,#BFEEFF 100%);
  -webkit-box-shadow: 0 10px 16px -10px rgba(85, 156, 251, 0.8);
  -moz-box-shadow: 0 10px 16px -10px rgba(85, 156, 251, 0.8);
  box-shadow: 0 10px 16px -10px rgba(85, 156, 251, 0.8);
}

.btn3{
  background: rgb(255, 167, 1);
  background:url('../../assets/img/pest/house/tuifang.svg') bottom right no-repeat,linear-gradient(90deg, #FFA701 0%,#FFE28B 100%);
  -webkit-box-shadow: 0 10px 16px -10px rgba(255, 167, 1, 0.8);
  -moz-box-shadow: 0 10px 16px -10px rgba(255, 167, 1, 0.8);
  box-shadow: 0 10px 16px -10px rgba(255, 167, 1, 0.8);
  position:relative;
}


.discount{
    position: absolute;
    top: 12px;
    right: 0;
}

</style>



// WEBPACK FOOTER //
// src/pages/pest/step1.vue